import React from 'react';
import { Row, Col, Button, Card, Icon } from 'antd';
import { Link } from 'react-router-dom';
export default class Component extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

    }
    render() {
        return (<div style={{padding:'0 10px 39px'}}>
            <Row gutter={22}>
                <Col span={8} >
                    <Card className='text-center' style={{ height: 364 }}>
                        <div style={{ paddingTop: 30 }}>
                            <Icon type='file-text' style={{ color: '#2996EB', fontSize: 100, marginBottom: 30 }} />
                            <p style={{ marginBottom: 20, color: '#71787E', fontSize: 16 }}>认证历史查询</p>
                            <p style={{ marginBottom: 45, color: '#99A9BF', height: 21 }}>按税期查询企业进项认证结果</p>
                        </div>
                        <Button><Link to="/workbench/app/Kingxunlian.VATConfirmReport">查看</Link></Button>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card className='text-center' style={{ height: 364 }}>
                        <div style={{ paddingTop: 30 }}>
                            <Icon type='file-text' style={{ color: '#2996EB', fontSize: 100, marginBottom: 30 }} />
                            <p style={{ marginBottom: 20, color: '#71787E', fontSize: 16 }}>税率分类汇总表</p>
                            <p className='' style={{ marginBottom: 45, color: '#99A9BF', height: 21 }}>按税率分类统计企业在一个税期内的认证结果，并打印认证结果通知书</p>
                        </div>
                        <Button><Link to="/workbench/app/Kingxunlian.VATConfirmReport/?active=classification">查看</Link></Button>
                    </Card>
                </Col>
            </Row>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/AuthStatics.tsx